let Widget3dsoft = require('./Main.js');

Widget3dsoft.prototype.beforeSendAjax = function (xhr, self) {
    xhr.setRequestHeader("Authorization", "BEARER " + self.sJWT);
};

/**
 * Show the form to search clients
 * @returns {undefined}
 */
Widget3dsoft.prototype.showFormConnexionUser = function (sShowTab) {
    var self = this;

    $(self.sClass + ' .glyphToggleWidget').click(function () {
        $(self.sClass).height() < 60 ? $(self.sClass).css('height', '100%') : $(self.sClass).css('height', '60px');
        $(self.sClass + ' .3dsoft-glyph-sub').toggleClass('glyphicon-collapse-down').toggleClass('glyphicon-collapse-up');
        self.adaptDimensions(self);
    });
    this.sStep = 'stepConnexion';

    if (self.sHtmlConnexionUser != undefined) {
        $(self.sClass).html(self.sHtmlConnexionUser);
        $(self.sClass + ' .widget3Dsoft-article nav').css('display', 'none');
        if (sShowTab == true) {
            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.SEARCH_CLIENT_ERROR_PARAMS);
            $(self.sClass + ' .widget3Dsoft-message').show();
        }
        self.ConnexionUser();
        $(self.sClass + ' .widget3Dsoft-loading').hide();
        self.bAjaxTermine3Dsoft = true;

        self.adaptDimensions(self);
    } else {
        self.ajax('GET',
            this.sServerURL + 'widget/form-connexion-user' + this.sParamsGet, {},
            function (response, statut) {

                $(self.sClass).html(response);
                self.sHtmlConnexionUser = response;
                self.bAjaxTermine3Dsoft = true;
                if (sShowTab == true) {
                    $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.SEARCH_CLIENT_ERROR_PARAMS);
                    $(self.sClass + ' .widget3Dsoft-message').show();
                }
                $(self.sClass + ' .widget3Dsoft-article nav').css('display', 'none');
                self.ConnexionUser();

                if (self.sVersion != self.oSite.sVersionWidget) {
                    $('#widget_version').prepend('V' + self.sVersion);
                    $('#widget_version i').show();
                }

                self.adaptDimensions(self);
            }
        );
    }


    return false;
};



Widget3dsoft.prototype.ConnexionUser = function () {
    var self = this;

    $(self.sClass + ' .btnConnexionUser').click(function () {

        $(self.sClass + ' .widget3Dsoft-message').hide();

        sUsername = $(self.sClass + ' .widget3Dsoft-username').val();
        sMdp = $(self.sClass + ' .widget3Dsoft-password').val();

        if ((sUsername === undefined || sUsername === '') ||
            (sMdp === undefined || sMdp === '')) {

            $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.CLIENT_MSG_SEARCH_FIELDS_EMPTY);
            $(self.sClass + ' .widget3Dsoft-message').show();
        } else {


            self.ajax('POST',
                self.sServerURL + 'rest/utilisateur/profil' + self.sParamsGet, {
                    sClientName: self.sClientName,
                    sCfaLibelle: self.sCfaLibelle,
                    sProfil: sUsername,
                    sPassword: sMdp
                },
                function (response) {

                    if (bIEOld3Dsoft) {
                        response = JSON.parse(response);
                    }

                    if (response.bSuccess == true) {


                        self.oUser.sUsername = response.oUtilisateur.profil;
                        self.oUser.nom = response.oUtilisateur.nom;
                        self.oUser.prenom = response.oUtilisateur.prenom;
                        self.oUser.iId = response.oUtilisateur.id;
                        self.rendezvous.iIdUti = self.oUser.iId;
                        sessionStorage.setItem("widget3Dsoft-UserToken", response.sJWT);

                        self.showFormSearchClient();

                    } else {
                        $(self.sClass + ' .widget3Dsoft-message').html(self.sLanguage.SEARCH_CLIENT_ERROR_PARAMS);
                        $(self.sClass + ' .widget3Dsoft-message').show();
                    }
                    self.bAjaxTermine3Dsoft = true;
                    self.adaptDimensions(self);
                }, true);
        }


    });
};
